import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

var _excluded = ["type"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { injectable } from 'inversify';
import 'reflect-metadata';
var lightTypeUniformMap = {
  directional: {
    lights: 'u_DirectionalLights',
    num: 'u_NumOfDirectionalLights'
  },
  spot: {
    lights: 'u_SpotLights',
    num: 'u_NumOfSpotLights'
  }
};
var DEFAULT_LIGHT = {
  type: 'directional',
  direction: [1, 10.5, 12],
  ambient: [0.2, 0.2, 0.2],
  diffuse: [0.6, 0.6, 0.6],
  specular: [0.1, 0.1, 0.1]
};
var DEFAULT_DIRECTIONAL_LIGHT = {
  direction: [0, 0, 0],
  ambient: [0, 0, 0],
  diffuse: [0, 0, 0],
  specular: [0, 0, 0]
};
var DEFAULT_SPOT_LIGHT = {
  position: [0, 0, 0],
  direction: [0, 0, 0],
  ambient: [0, 0, 0],
  diffuse: [0, 0, 0],
  specular: [0, 0, 0],
  constant: 1,
  linear: 0,
  quadratic: 0,
  angle: 14,
  exponent: 40,
  blur: 5
};
var COLOR_ATTRIBUTES = ['ambient', 'diffuse', 'specular'];
export function generateLightingUniforms(lights) {
  var lightsMap = {
    u_DirectionalLights: new Array(3).fill(_objectSpread({}, DEFAULT_DIRECTIONAL_LIGHT)),
    u_NumOfDirectionalLights: 0,
    u_SpotLights: new Array(3).fill(_objectSpread({}, DEFAULT_SPOT_LIGHT)),
    u_NumOfSpotLights: 0
  };

  if (!lights || !lights.length) {
    lights = [DEFAULT_LIGHT];
  }

  lights.forEach(function (_ref, i) {
    var _ref$type = _ref.type,
        type = _ref$type === void 0 ? 'directional' : _ref$type,
        rest = _objectWithoutProperties(_ref, _excluded);

    var lightsUniformName = lightTypeUniformMap[type].lights;
    var lightsNumUniformName = lightTypeUniformMap[type].num;
    var num = lightsMap[lightsNumUniformName];
    lightsMap[lightsUniformName][num] = _objectSpread(_objectSpread({}, lightsMap[lightsUniformName][num]), rest);
    lightsMap[lightsNumUniformName]++;
  });
  return lightsMap;
}
var LightingPlugin = (_dec = injectable(), _dec(_class = function () {
  function LightingPlugin() {
    _classCallCheck(this, LightingPlugin);
  }

  _createClass(LightingPlugin, [{
    key: "apply",
    value: function apply(layer) {
      layer.hooks.beforeRender.tap('LightingPlugin', function () {
        var _layer$getLayerConfig = layer.getLayerConfig(),
            enableLighting = _layer$getLayerConfig.enableLighting;

        if (enableLighting) {
          layer.models.forEach(function (model) {
            return model.addUniforms(_objectSpread({}, generateLightingUniforms()));
          });
        }
      });
    }
  }]);

  return LightingPlugin;
}()) || _class);
export { LightingPlugin as default };
//# sourceMappingURL=LightingPlugin.js.map